import CPostItem from "core/components/CPostItem/CPostItem";
import CUser from "core/components/CUser/CUser";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
import { memo } from "react";

interface ItemCommunityProps {
  community: any;
  key: number;
  border?: boolean;
  tab?: string;
}

const ItemCommunity = ({ community, key, border, tab }: ItemCommunityProps) => {
  const navigate = useCustomNavigate();
  const handleClick = (community: any) => {
    navigate(RouterName.POST_DETAIL.replace(":id", community.id)+`?tab=${tab}`);
  };
  const getThumbnail = (community: any) => {
    if (community?.shared_post?.id) {
      return community?.shared_post?.files?.find((file: any) =>
        file.mime_type.includes("image")
      )?.url?.thumbnail;
    }
    return community?.files?.find((file: any) => file.mime_type.includes("image"))?.url
      ?.thumbnail;
  };

  return (
    <div
      className={`${border ? 'border border-[#EEEEEE] p-[6px] ' : ''} rounded-[8px] mb-2`}
      key={key}
      onClick={() => handleClick(community)}
    >
      <CUser
        avatar={community?.user?.avatar?.url?.thumbnail}
        name={community.user?.name || community.user?.username || ""}
        date={community.created_at}
        id={community?.user?.id}
      />
      <CPostItem
        title={community.content}
        thumbnail={getThumbnail(community)}
        type="thumbnail"
        likeCount={community?.total_likes}
        commentCount={community?.total_comments}
        item={community}
      />
    </div>
  );
};

export default memo(ItemCommunity);
